<template>
  <div class="homepage_box">
    <!-- 顶部 -->
    <!-- <dingbu></dingbu> -->
    <!-- 底部 -->
    <div class="home_content">
      <div class="bannerbox">
        <div class="block">
          <el-carousel>
            <el-carousel-item v-for="(item,index) in bannerlist" :key="index">
              <img :src=item.pic alt="" @click="tobanner(item.bannerUrl)">
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- <div class="majorbox">
          <ul>
            <li>
              <img src="../../assets/装备制造.png" alt="">
              <span>装备制造</span>
            </li>
            <li>
              <img src="../../assets/电子信息.png" alt="">
              <span>电子与信息</span>
            </li>
            <li>
              <img src="../../assets/运输.png" alt="">
              <span>交通运输</span>
            </li>
            <li>
              <img src="../../assets/医药箱.png" alt="">
              <span>医药卫生</span>
            </li>
            <li>
              <img src="../../assets/教育.png" alt="">
              <span>思政教育</span>
            </li>
            <li>
              <img src="../../assets/工程.png" alt="">
              <span>土木建筑</span>
            </li>
            <li>
              <img src="../../assets/雷达.png" alt="">
              <span>资源勘探</span>
            </li>
            <li>
              <img src="../../assets/农林牧渔.png" alt="">
              <span>农林牧渔</span>
            </li>
            <li>
              <img src="../../assets/安全.png" alt="">
              <span>安全工程</span>
            </li>
          </ul>
        </div> -->
      </div>

      <div class="jingxuan">
        <div class="jingxuanExp_title">
          <span>
            精选实验
          </span>
          <span @click="toexp" class="seeMore"><i class="el-icon-caret-right"></i> 查看更多</span>
        </div>
        <div class="jingxuanExp_titlephone">
          <span>
            <div class="transverse_line"></div> 精选实验<div class="transverse_line"></div>
          </span>
        </div>
        <div class="jingxuanList_box">
          <div @click="toexpxiangqing(goodexp.experimentId)">
            <div class="img_box">
              <img :src=goodexp.pic alt="">
            </div>
            <span>{{ goodexp.name }}</span>
            <div class="jiaoxuesuoshu">
              <span>{{ goodexp.deptName }} | {{ goodexp.nickName }} </span>
              <div class="dianzanBox">
                <div class="dianzan">
                  浏览人数： {{ goodexp.browseNum }}
                </div>
                <div class="shoucang">
                  收藏人数： {{ goodexp.shareCount }}
                </div>
              </div>
            </div>
          </div>
          <ul class="jingxuan_ul">
            <li v-for="item in expListnoone" :key="item.experimentId" @click="toexpxiangqing(item.experimentId)">
              <div class="img_box">
                <img :src=item.pic alt="">
              </div>
              <span>{{ item.name }}</span>
              <div class="jiaoxuesuoshu">
                <span style="white-space: nowrap;">{{ item.deptName }} | {{ item.nickName }} </span>

                <div class="dianzanBox">
                  <div class="dianzan">
                    <i class="el-icon-view"></i>{{ item.browseNum }}
                  </div>
                  <div class="shoucang">
                    <i class="el-icon-star-off"></i>{{ item.collectCount }}
                  </div>
                </div>
              </div>
            </li>
            <li></li>
          </ul>
        </div>

      </div>
      <div class="tongzhiand">
        <div class="jingxuanVideo">
          <div class="video_box">
            <span>精选课程</span>
            <span @click="tovideo" class="seeMore"><i class="el-icon-caret-right"></i> 查看更多</span>
            <!-- <span @click="tovideo"><i class="el-icon-refresh"></i> 换一换</span> -->
          </div>
          <div class="jingxuanExp_titlephone">
            <span>
              <div class="transverse_line"></div> 精选课程<div class="transverse_line"></div>
            </span>
          </div>
          <ul class="video_list">
            <li v-for="item in courseList" :key="item.courseId" @click="tocoursexiangqing(item.courseId)">
              <div class="img_box">
                <div class="box_shadow">
                  <i class="el-icon-video-play"></i>
                </div>
                <img :src=item.pic alt="">
              </div>
              <div class="jieshao">
                <span>{{ item.name }}</span>
                <span>
                  <span>{{ item.nickName }} | {{ item.equipment }}</span>
                  <div class="dianzanBox">
                    <div class="dianzan">
                      <i class="el-icon-view"></i> {{ item.browseNum }}
                    </div>
                    <div class="shoucang">
                      <i class="el-icon-star-off"></i>{{ item.collectCount }}
                    </div>
                  </div>
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div class="tongzhi">
          <div class="paihang_box">
            <span>热度排行</span>
            <div class="nav_box">
              <span :class="{ chosed_nav: navData == 1 }" @click="navpaihang(1)">实验</span>
              <span :class="{ chosed_nav: navData == 2 }" @click="navpaihang(2)">课程</span>
            </div>
          </div>
          <div class="jingxuanExp_titlephone paihang_top">
            <span>
              <div class="transverse_line"></div> 热度排行<div class="transverse_line"></div>
            </span>
            <div class="nav_box">
              <span :class="{ chosed_nav: navData == 1 }" @click="navpaihang(1)">实验</span>
              <span :class="{ chosed_nav: navData == 2 }" @click="navpaihang(2)">课程</span>
            </div>
          </div>
          <div class="paihanglist_box">
            <ul>
              <div class="paihang_jieshao">
                <img src="../../assets/renqi.png" alt="">
                <span>人气指数</span>
              </div>
              <li v-for="item in renqiExp" :key="item.id" @click="topage(item.id)">
                <span> <span class="pnum">{{ item.num }}</span> {{ item.title }}</span>
                <div class="cover_img">
                  <img :src="item.pic" alt="">
                </div>
                <div>
                  <span v-if="navData == 1">{{ item.deptName }}</span>
                  <span v-if="navData == 2">{{ item.major }}</span>
                  <div>
                    <i class="el-icon-view"></i>{{ item.browseNum }}
                  </div>
                </div>
              </li>
            </ul>
            <ul>
              <div class="paihang_jieshao">
                <img src="../../assets/tongji.png" alt="">
                <span>共享指数</span>
              </div>
              <li v-for="item in gongxiangExp" :key="item.id" @click="topage(item.id)">
                <span> <span class="pnum">{{ item.num }}</span> {{ item.title }}</span>
                <div class="cover_img">
                  <img :src="item.pic" alt="">
                </div>
                <div>
                  <span v-if="navData == 1">{{ item.deptName }}</span>
                  <span v-if="navData == 2">{{ item.major }}</span>
                  <div>
                    <i class="el-icon-view"></i>{{ item.shareCount }}
                  </div>
                </div>
              </li>
            </ul>
            <ul>
              <div class="paihang_jieshao">
                <img src="../../assets/hudong.png" alt="">
                <span>互动指数</span>
              </div>
              <li v-for="item in hudongExp" :key="item.id" @click="topage(item.id)">
                <span> <span class="pnum">{{ item.num }}</span> {{ item.title }}</span>
                <div class="cover_img">
                  <img :src="item.pic" alt="">
                </div>
                <div>
                  <span v-if="navData == 1">{{ item.deptName }}</span>
                  <span v-if="navData == 2">{{ item.major }}</span>
                  <div>
                    <i class="el-icon-view"></i>{{ item.interactionCount }}
                  </div>
                </div>
              </li>
            </ul>
            <ul>
              <div class="paihang_jieshao">
                <img src="../../assets/shoucang.png" alt="">
                <span>吸引指数</span>
              </div>
              <li v-for="item in shoucangExp" :key="item.id" @click="topage(item.id)">
                <span> <span class="pnum">{{ item.num }}</span> {{ item.title }}</span>
                <div class="cover_img">
                  <img :src="item.pic" alt="">
                </div>
                <div>
                  <span v-if="navData == 1">{{ item.deptName }}</span>
                  <span v-if="navData == 2">{{ item.major }}</span>
                  <div>
                    <i class="el-icon-view"></i>{{ item.collectCount }}
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <div class="tongzhiandnews">
        <div>
          <div class="gonggao_title">
            <span>通知公告</span>
            <span @click="togonggao" style="cursor: pointer;"><i class="el-icon-caret-right"></i> 查看更多</span>
          </div>
          <div class="jingxuanExp_titlephone">
            <span>
              <div class="transverse_line"></div> 通知公告<div class="transverse_line"></div>
            </span>
          </div>
          <ul>
            <li v-for="item in tongzhiList" :key="item.id" @click="totongzhixiangqing(item.id)">
              <div class="title_box">
                <div></div>
                <span>{{ item.title }}</span>
              </div>
              <div class="time_box">
                {{ item.createDatetime.slice(0, 10) }}
              </div>
            </li>
          </ul>
        </div>
        <div>
          <div class="gonggao_title">
            <span>新闻资讯</span>
            <span @click="toxinwen" style="cursor: pointer;"><i class="el-icon-caret-right"></i> 查看更多</span>
          </div>
          <div class="jingxuanExp_titlephone">
            <span>
              <div class="transverse_line"></div> 新闻资讯<div class="transverse_line"></div>
            </span>
          </div>
          <ul>
            <li v-for="item in newsList" :key="item.id" @click="toxinwenxiangqing(item.id)">
              <div class="title_box">
                <div></div>
                <span>{{ item.title }}</span>
              </div>
              <div class="time_box">
                {{ item.createTime.slice(0, 10) }}
              </div>
            </li>

          </ul>
        </div>
      </div>
      <div class="hezuo">
        <div class="hezuo_title">
          <span>合作院校</span>
        </div>
        <div class="yuanxiao">
          <ul class="yuanxiaoList">
            <li>
              <img
                src="
              http://img601.yun300.cn/repository/image/e4225aaa-2193-4644-932d-abe251762ad2.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>贵州民族大学</span>
            </li>
            <li>
              <img
                src="
              http://img601.yun300.cn/repository/image/3ff9e1d5-bcf8-465a-a4bb-e3807ea54f50.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>华东交通大学</span>
            </li>
            <li>
              <img
                src="
              http://img601.yun300.cn/repository/image/db8e7ffc-e429-4b72-95ce-2ea1411f3f09.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>南京师范大学</span>
            </li>
            <li>
              <img
                src="http://img601.yun300.cn/repository/image/3868d532-d02e-49b1-95e6-5b5c529add9d.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>重庆工商大学</span>
            </li>
            <li>
              <img
                src="http://img601.yun300.cn/repository/image/90b894ba-1f86-448a-9579-fecbe421d99a.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>南京理工大学</span>
            </li>
            <li>
              <img
                src="
              http://img601.yun300.cn/repository/image/db8e7ffc-e429-4b72-95ce-2ea1411f3f09.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>南京师范大学</span>
            </li>
            <li>
              <img
                src="http://img601.yun300.cn/repository/image/88c7ab99-943e-4949-acfc-520047599760.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>江南大学</span>
            </li>
            <li>
              <img
                src="http://img601.yun300.cn/repository/image/6824eca5-669a-45bb-b44c-156a0ea7a345.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>河海大学</span>

            </li>
            <li>
              <img
                src="http://img601.yun300.cn/repository/image/9a2add2d-7769-4ea3-aad7-0039d37225af.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>南京农业大学</span>
            </li>

            <li>
              <img
                src="http://img601.yun300.cn/repository/image/76254159-7f0e-4aef-a2a4-406952be9897.jpg?tenantId=263569&viewType=1&k=1680580599000"
                alt="">
              <span>陆军工程大学</span>
            </li>
          </ul>
        </div>
      </div>

    </div>
    <!-- 底部 -->
    <!-- <foot></foot> -->

  </div>
</template>

<script>
import dingbu from '../dingbu/index.vue'
import foot from '../foot/foot.vue'
import axios from "axios"
import daohanglan from '../daohanglan/index.vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { getExpliulan, getExphudong, getExpgongxiang, getExpshoucang, getCoursegongxiang, getCoursehudong, getCourseliulan, getCourseshoucang } from "../../api/home";
import { getgonggao, getnews, getgoodExp, getbanner, getjxcourse } from "@/api/hometoken"
import { Logins } from "@/api/index.js"
import { BASE_URL } from "@/utils/request.js"
export default {
  name: "ShouYe",
  components: {
    dingbu,
    foot,
    daohanglan,
    Editor,
    Toolbar
    // fuweben
  },
  data() {
    return {
      bannerlist: '',
      // 控制实验与课程
      navData: 1,
      banner: [
        {
          url: 'https://www.ilab-x.com/img?id=236161'
        },
        {
          url: 'https://www.ilab-x.com/img?id=236160'
        }
      ],
      // 人气实验
      renqiExp: [],
      // 共享实验
      gongxiangExp: [],
      // 互动实验
      hudongExp: [],
      // 收藏实验
      shoucangExp: [],
      // 通知列表
      tongzhiList: [],
      //新闻列表
      newsList: [],
      // 精选实验
      expList: [],
      goodexp: {},
      expListnoone: [],
      courseList: [],
      baseUrl: BASE_URL,
    }
  },
  created() {
    axios(this.baseUrl + 'getInfo', {
      method: "get",
      headers: {
        token: localStorage.getItem('token'),
                  Authorization:"Bearer "+localStorage.getItem("token"),
      },
    }).then((res) => {
      // console.log(res);
      if (res.data.code == 200) {
        localStorage.setItem('username', res.data.user.nickName);
        localStorage.setItem('userId', res.data.user.userId);
        localStorage.setItem('classId', res.data.classId);
        localStorage.setItem('roles', res.data.user.remark);
        localStorage.setItem('sex', res.data.user.sex);
        localStorage.setItem('avatar', this.baseUrl + res.data.user.avatar)
      } else {
        Logins({
          username: "20230000",
          password: "123456"
        }).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            localStorage.setItem('token', res.data.token);
            this.GetId()
          }
        })
        setTimeout(() => {
          // alert("登录已失效")
          // location.reload()
        }, 500);
      }
    })
  },
  methods: {
    // 首次进入后访客登录
    visit() {
      Logins({
        username: "20230000",
        password: "123456"
      }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          localStorage.setItem('token', res.data.token);
          this.GetId()
        } 
      })
    },
    //获取角色id
    GetId() {
      axios(this.baseUrl + '/getInfo', {
        method: "get",
        headers: {
          token: localStorage.getItem('token'),
                    Authorization:"Bearer "+localStorage.getItem("token"),
        },
      })
        .then((res) => {
          localStorage.setItem('username', res.data.user.nickName);
          localStorage.setItem('userId', res.data.user.userId);
          localStorage.setItem('classId', res.data.classId);
          localStorage.setItem('roles', res.data.user.remark);
          localStorage.setItem('sex', res.data.user.sex);
          localStorage.setItem('avatar', this.baseUrl + res.data.user.avatar)
        })
    },

    totongzhixiangqing(id) {
      this.$router.push({
        path: '/tongzhi'
      })
      localStorage.setItem("inform", id)
    },
    toxinwenxiangqing(id) {
      this.$router.push({
        path: '/xinwen'
      })
      localStorage.setItem("news", id)
    },
    togonggao() {
      this.$router.push({
        path: '/tongzhi'
      })
      localStorage.removeItem("inform")
    },
    toxinwen() {
      this.$router.push({
        path: '/xinwen'
      })
      localStorage.removeItem("news")
    },
    // 点击跳转
    topage(id) {
      if (this.navData == 1) {
        this.$router.push({
          path: '/shiyan?id=' + id
        })
      } else {
        this.$router.push({
          path: '/videoxiangqing?id=' + id
        })
      }
    },
    // 跳转精选实验
    toexpxiangqing(id) {
      this.$router.push({
        path: '/shiyan?id=' + id
      })
    },
    tocoursexiangqing(id) {
      this.$router.push({
        path: '/videoxiangqing?id=' + id
      })
    },
    // 跳转banner链接
    tobanner(url) {
      window.open(url, "_bank")
    },
    // 获取精选课程
    getcourselist() {
      getjxcourse().then(res => {
        if (res.data.code == 200) {
          this.courseList = res.data.rows
        }
      })
    },
    // 获取banner
    getBannerlist() {
      getbanner().then(res => {
        if (res.data.code == 200) {
          this.bannerlist = res.data.rows
        }
        // console.log(this.bannerlist);
      })
    },
    // 跳转实验列表
    toexp() {
      this.$router.push({
        path: '/shouye'
      })
    },
    tovideo() {
      this.$router.push({
        path: '/videopage'
      })
    },
    // 点击切换排行
    navpaihang(data) {
      this.navData = data
      this.getrenqiexp()
      this.getshoucangexp()
      this.getgongxiangexp()
      this.gethudongexp()
    },
    // 获取精选实验
    getjingxuanExp() {
      getgoodExp().then(res => {
        if (res.data.code == 200) {
          this.expList = res.data.rows
          this.goodexp = this.expList[0]
          this.expListnoone = this.expList.slice(1, 10)
        }
      })
    },
    // 获取人气实验
    getrenqiexp() {
      if (this.navData == 1) {
        getExpliulan().then(res => {
          if (res.data.code == 200) {
            // console.log(res.data);
            this.renqiExp = res.data.rows
            let num = 1
            this.renqiExp.forEach(item => {
              item.num = num;
              num++
            })
          }
        })
      } else {
        getCourseliulan().then(res => {
          if (res.data.code == 200) {
            // console.log(res.data);
            this.renqiExp = res.data.rows
            let num = 1
            this.renqiExp.forEach(item => {
              item.num = num;
              num++
            })
          }
        })
      }
    },
    // 获取收藏实验
    getshoucangexp() {
      if (this.navData == 1) {
        getExpshoucang().then(res => {
          if (res.data.code == 200) {
            this.shoucangExp = res.data.rows
            let numa = 1
            this.shoucangExp.forEach(item => {
              item.num = numa;
              numa++
            })
          }
        })
      } else {
        getCourseshoucang().then(res => {
          if (res.data.code == 200) {
            this.shoucangExp = res.data.rows
            let numa = 1
            this.shoucangExp.forEach(item => {
              item.num = numa;
              numa++
            })
          }
        })
      }
    },
    // 获取共享
    getgongxiangexp() {
      if (this.navData == 1) {
        getExpgongxiang().then(res => {
          if (res.data.code == 200) {
            this.gongxiangExp = res.data.rows
            let numb = 1
            this.gongxiangExp.forEach(item => {
              item.num = numb;
              numb++
            })
          }
        })
      } else {
        getCoursegongxiang().then(res => {
          if (res.data.code == 200) {
            this.gongxiangExp = res.data.rows
            let numb = 1
            this.gongxiangExp.forEach(item => {
              item.num = numb;
              numb++
            })
          }
        })
      }

    },
    // 获取互动
    gethudongexp() {
      if (this.navData == 1) {
        getExphudong().then(res => {
          if (res.data.code == 200) {
            this.hudongExp = res.data.rows
            let numc = 1
            this.hudongExp.forEach(item => {
              item.num = numc;
              numc++
            })
          }
        })
      } else {
        getCoursehudong().then(res => {
          if (res.data.code == 200) {
            this.hudongExp = res.data.rows
            let numc = 1
            this.hudongExp.forEach(item => {
              item.num = numc;
              numc++
            })
          }
        })
      }
    },
    // 获取公告
    getgonggaoway() {
      getgonggao({
        pageSize: 7
      }).then(res => {
        if (res.data.code == 200) {
          this.tongzhiList = res.data.rows
        }
      })
    },
    // 获取
    getNewsway() {
      getnews({
        pageSize: 7
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          this.newsList = res.data.rows
        }
      })
    }
  },
  mounted() {
    setTimeout(() => {
      this.getrenqiexp()
      this.getshoucangexp()
      this.getgongxiangexp()
      this.gethudongexp()
      this.getBannerlist()
      this.getgonggaoway()
      this.getNewsway()
      this.getjingxuanExp()
      this.getcourselist()
    }, 0);

  }
}
</script>
<style lang="scss">
.seeMore {
  margin-right: 1000px;
  padding: 2px 5px;
  border-radius: 20px;
  font-size: 12px;
  cursor: pointer;
}

.el-carousel--horizontal {
  height: 100%;
}

.el-carousel__item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang='scss' scoped>
.outbig_box {
  background-color: rgba(0, 0, 0, 1)
}


.cover_img {
  width: 100%;
  display: flex;
  align-items: center;
  // justify-content: center!important;
  display: none !important;

  img {
    width: 60%;
    border-radius: 3px;
  }
}

.paihanglist_box>ul>li:hover .cover_img {
  display: flex !important;
}

.majorbox {
  background-color: #0957D9;
  display: flex;
  position: absolute;
  z-index: 99;
  width: 100%;
  padding: 40px 0;
  bottom: -75px;
  border-radius: 8px;
  max-width: 1400px;

  >ul {
    width: 100%;
    display: flex;
    justify-content: space-evenly;

    >li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      >img {
        height: 50px;
        width: 50px;
      }

      >span {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
      }

    }

  }
}

.home_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  padding-top: 0;
  background-color: #fff;

  >.bannerbox {
    width: 100%;
    // height: 600px;
    display: flex;
    justify-content: center;
    font-size: 50px;
    align-items: center;
    position: relative;

    >.block {
      width: 100%;
      // height: 100%;
      position: relative;
      display: flex;

      div {
        width: 100% !important;
        display: flex;
        overflow: hidden;
        height: auto;
      }

      img {
        // height: 100%;
        width: 100%
      }

    }


  }

  //   .bannerbox:before {
  //   content: '';
  //   display: block;
  //   padding-bottom: 31.25%; /* 设置padding-bottom为宽度的56.25%，这样高度就是宽度的1.17647058823529411764705882352941% */
  // }

  >.jingxuan {
    max-width: 1400px;
    height: 500px;
    width: 100%;
    border-radius: 10px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    margin-top: 50px;

    >.jingxuanList_box {

      display: flex;
      max-width: 1400px;
      align-items: flex-start;
      height: 472px;

      >div:nth-child(1) {
        height: 450px;
        cursor: pointer;
        width: 536px;
        background-color: #f8f8f8;

        >span:nth-child(2) {
          font-size: 18px;
          margin-top: 10px;
          display: block;
          box-sizing: border-box;
          padding-left: 10px;
        }

        >.jiaoxuesuoshu {
          font-size: 14px;
          display: block;
          flex-direction: column;
          margin-top: 10px;
          box-sizing: border-box;
          padding-left: 10px;

          >span {
            display: block;
            margin-bottom: 35px;
          }

          >.dianzanBox {
            display: flex;

            >div {
              margin-right: 20px;
            }
          }
        }

        >.img_box {
          overflow: hidden;
          width: 100%;
          border-radius: 5px;

          img {
            width: 536px;
            border-radius: 8px;
            height: 290px;
          }
        }
      }

      >div:nth-child(1):hover img {
        transition: all 0.3s;
        transform: scale(1.1);
      }

      >.jingxuan_ul {
        width: 100%;
        height: 100%;
        display: flex;
        box-sizing: border-box;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-left: 30px;

        >li:hover {
          img {
            transform: scale(1.1);
            transition: all 0.3s;
          }
        }

        >li {
          width: 258px;
          height: 216px;
          margin-bottom: 8px;
          display: flex;
          flex-direction: column;
          border-radius: 5px;
          overflow: hidden;
          cursor: pointer;

          >.img_box {
            position: relative;
            overflow: hidden;
            height: 150px;
            width: 100%;

            >div {
              position: absolute;
              left: -1px;
              top: -1px;
              font-size: 12px;
              color: #fff;
              font-weight: bold;
              padding: 5px 10px;
              border-radius: 5px 0 10px 0;
              z-index: 11;
            }

            >.jingxuan_span {
              background-image: -webkit-linear-gradient(bottom, red, #fd8403, yellow);
            }

            >.xinzeng_span {
              background-image: -webkit-linear-gradient(bottom, rgb(92, 235, 40), #148f30, yellow);
            }

            >img {
              width: 100%;
              border-radius: 5px;
              height: 100%;
            }
          }



          >span {
            width: 100%;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 20px;
            display: block;
            margin-bottom: 10px;
            margin-top: 10px;
          }

          >.jiaoxuesuoshu {
            display: flex;
            font-size: 12px;
            color: #999;
            padding: 2px 0;
            justify-content: space-between;
            display: flex;

            >span {
              margin-bottom: 2px;
            }

            >.dianzanBox {
              font-size: 12px;
              color: #999;
              display: flex;

              >div {
                white-space: nowrap;
                margin-right: 10px;

                >i {
                  margin-right: 5px;
                }
              }
            }
          }
        }
      }
    }

    >.jingxuanExp_title {
      width: 100%;
      margin-bottom: 10px;
      padding: 5px;
      display: flex;
      justify-content: space-between;
      max-width: 1400px;
      box-sizing: border-box;
      align-items: center;
      padding-left: 0;

      >span:first-child {
        border-left: 5px solid #0958d9;
        display: flex;
        align-items: center;
        font-weight: bold;
        padding-left: 10px;
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
      }

      >span:last-child {
        cursor: pointer;
        font-size: 14px;
        margin-right: 20px;
      }

      >span:last-child:hover {
        color: #0958d9;
      }
    }
  }


  >.tongzhiand {
    max-width: 1400px;
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 10px;
    flex-direction: column;
    margin-bottom: 20px;

    >div:nth-child(1) {
      width: 100%;
      border-radius: 10px;
      height: 100%;
      box-sizing: border-box;

      >.video_box {
        width: 100%;
        margin-bottom: 10px;
        padding: 5px;
        display: flex;
        justify-content: space-between;
        max-width: 1400px;
        box-sizing: border-box;
        align-items: center;
        padding-left: 10px;


        >span:nth-child(1) {
          border-left: 5px solid #0958d9;
          display: flex;
          align-items: center;
          padding-left: 10px;
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
        }

        >span:last-child {
          cursor: pointer;
          font-size: 14px;
          margin-right: 20px;
        }

        >span:last-child:hover {
          color: #0958d9;
        }
      }

      >.video_list {
        width: 100%;
        height: 247px;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        justify-content: space-between;

        >li:hover {
          >.img_box {
            .box_shadow {
              opacity: 0.8;
            }
          }

        }

        >li {
          width: 258px;
          margin-bottom: 1.5%;
          height: 100%;
          background-color: #f9f9f9;
          border-radius: 5px;
          overflow: hidden;
          display: flex;
          cursor: pointer;
          align-items: center;
          flex-direction: column;
          margin-right: 20px;

          >.img_box {
            height: 140px;
            width: 100%;
            border-radius: 5px;
            overflow: hidden;
            position: relative;

            >.box_shadow {
              width: 100%;
              transition: all 0.3s;
              position: absolute;
              left: 0;
              bottom: 0;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              opacity: 0;
              background-color: rgba(0, 0, 0, 0.5);

              >i {
                color: #fff;
                font-size: 50px;
                opacity: 0.5;

              }
            }

            >img {
              height: 100%;
              width: 100%;
            }

          }

          >.jieshao {
            width: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            padding: 10px;

            >span {
              font-size: 14px;
              color: #999;
            }

            >span:nth-child(1) {
              font-size: 18px;
              margin-bottom: 10px;
              color: #333;

            }


            >span:last-child {
              display: flex;
              justify-content: space-evenly;
              flex-direction: column;

              >div {
                display: flex;
                margin-top: 10px;

                >div {
                  margin-right: 20px;
                }
              }
            }
          }

          >.start_video {
            width: 90px;
            height: 70%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            >i {
              font-size: 26px;
              background-image: -webkit-linear-gradient(bottom, #0958d9, #6d93ca, #bacbe4);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }

            >span {
              font-weight: bold;
              background-image: -webkit-linear-gradient(bottom, #0958d9, #6d93ca, #bacbe4);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }

            border-left: 1px dashed #bac5d5;
            display: flex;
          }
        }

        >li:last-child {
          margin-right: 0;
        }
      }
    }

    >div:nth-child(2) {
      width: 100%;
      margin-top: 30px;
      border-radius: 10px;
      height: 100%;
      box-sizing: border-box;
      padding: 20px 0;
      display: flex;
      flex-direction: column;

      >.paihang_box {
        width: 100%;
        height: 30px;
        box-sizing: border-box;
        padding-left: 10px;

        display: flex;
        justify-content: space-between;

        >.nav_box {
          display: flex;
          margin-right: 20px;
          border-radius: 20px;
          overflow: hidden;
          align-items: center;

          >span {
            padding: 5px 10px;
            background-color: #dbdbdb;
            color: #fff;
            height: 100%;
            display: flex;
            width: 50%;
            align-items: center;
            cursor: pointer;
            color: #333;
          }

          >.chosed_nav {
            background-color: #0958d9;
            color: #fff;
          }
        }

        >span {
          border-left: 5px solid #0958d9;
          display: flex;
          align-items: center;
          padding-left: 10px;
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
        }
      }



      >.paihanglist_box {
        height: 490px;
        display: flex;
        margin-top: 20px;
        justify-content: space-between;

        >ul {
          background-color: #f9f9f9;
          display: flex;
          width: 24%;
          flex-direction: column;
          padding: 20px;
          box-sizing: border-box;
          border-radius: 5px;

          >.paihang_jieshao {
            display: flex;
            align-items: center;

            >img {
              margin-right: 10px;
              width: 17px;
              height: 17px;
            }

            >span {
              font-size: 18px;
            }
          }

          >li {
            display: flex;
            align-items: center;
            width: 100%;
            padding: 12px 0;
            justify-content: space-between;
            border-bottom: 1px dashed #999;
            cursor: pointer;
            flex-direction: column;

            >div {
              width: 100%;
              display: flex;
              justify-content: space-between;
              font-family: MicrosoftYaHeiLight;
              font-size: 12px;
              letter-spacing: 0px;
              color: #999999;
              box-sizing: border-box;
              padding: 0 25px;
              padding-left: 10px;

            }




            >span {
              font-size: 16px;
              margin-right: 30px;
              white-space: nowrap;
              text-align: left;
              width: 85%;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-left: 5px;

              >.pnum {
                font-size: 18px;
                font-weight: bold;
                color: #666666;
              }
            }

            // >div {
            //   width: 10%;
            //   font-size: 12px;
            //   color: #999;
            //   display: flex;
            //   align-items: center;

            //   >i {
            //     margin-right: 1px;
            //   }
            // }
          }

          >li:last-child {
            border: none;
          }

          >li:nth-child(2) .pnum {
            color: #b00000;
          }

          >li:nth-child(3) .pnum {
            color: #ff7618;
          }

          >li:nth-child(4) .pnum {
            color: #ff9110;
          }
        }
      }

    }
  }

  >.tongzhiandnews {
    display: flex;
    width: 1400px;
    height: 351px;
    justify-content: space-between;
    padding: 0 8px;
    box-sizing: border-box;

    >div {
      width: 49%;
      height: 351px;
      display: flex;
      align-items: center;
      flex-direction: column;

      >.gonggao_title {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        padding-left: 10px;
        display: flex;
        justify-content: space-between;

        >span:nth-child(1) {
          border-left: 5px solid #0958d9;
          display: block;
          align-items: center;
          padding-left: 10px;
          font-size: 20px;
          font-family: MicrosoftYaHei-Bold;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
        }

        >span:last-child {
          font-size: 12px;
          white-space: nowrap;
          color: #999;
          margin-right: 20px;
        }
      }

      >ul {

        width: 100%;
        height: 302px;
        background-color: #f8f8f8;
        border-radius: 8px;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 20px 15px;

        >li {
          display: flex;
          height: 40px;
          justify-content: space-between;
          cursor: pointer;
          align-items: center;

          >div {
            display: flex;
            align-items: center;

            >div {
              margin-right: 15px;
              width: 10px;
              border-radius: 50%;
              height: 10px;
              background-color: #999999;
            }

            >span {
              width: 500px;
              height: 20px;
              font-family: MicrosoftYaHei;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #999999;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          >div:last-child {
            width: 100px;
            display: flex;
            align-items: center;
            height: 14px;
            font-family: MicrosoftYaHei;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
          }
        }

        >li:hover>div>div {
          background-color: #0958d9;
        }

        >li:hover>div>span {
          color: #0958d9;
          font-size: 16px;
        }
      }
    }
  }

  >.hezuo {
    max-width: 1400px;
    min-height: 300px;
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
    display: none;

    >.hezuo_title {
      >span {
        border-left: 5px solid #0958d9;
        display: flex;
        align-items: center;
        padding-left: 10px;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
      }
    }

    .yuanxiao {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      flex-direction: column;
      align-items: center;

      >ul {
        display: flex;
        flex-wrap: wrap;

        >li:nth-child(6) {
          margin-left: 70px;
        }

        >li:last-child {
          margin-right: 0;
        }

        >li {
          width: 17%;
          height: 60px;
          margin: 4px 10px;
          display: flex;
          align-items: center;
          margin-top: 20px;
          margin-right: 10px;

          >span {
            white-space: nowrap;
          }

          img {
            height: 100%;
          }
        }

        >li:hover {
          img {
            transition: all 0.3s;
            transform: scale(1.1);
          }
        }
      }
    }

  }
}
</style>
<style lang="scss">
.bannerbox .el-carousel__button {
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.bannerbox .el-carousel__arrow {
  background-color: transparent;
}

.bannerbox .el-icon-arrow-left {
  font-size: 50px;
  background-color: transparent;
  opacity: 0.8;
}

.bannerbox .el-icon-arrow-right {
  font-size: 50px;
  background-color: transparent;
  opacity: 0.8;
}
</style>
<style lang="scss">
.homepage_box {
  .el-carousel__container {
    width: 100%;
    overflow: hidden;
    display: flex;
    padding-bottom: 31.25%;
    height: auto;
  }
}
</style>
<style lang="scss" scoped>
.jingxuanExp_titlephone {
  display: none;
}

@media (max-width:550px) {
  .homepage_box {
    .jingxuan {
      margin-top: 10px;
      box-sizing: border-box;
      padding: 0 7.3%;
      height: auto;

      .jingxuanExp_title {
        display: none;

        >span:first-child {
          font-size: 18px;
        }

        >span:nth-child(2) {
          font-size: 12px;
          margin-right: 0;
        }
      }

      .jingxuanExp_titlephone {
        display: flex;

        >span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          margin-bottom: 15px;

          >.transverse_line {
            width: 20px;
            height: 3px;
            background: #0957D9;
            border-radius: 0px;
            margin: 0 8px;
          }
        }
      }

      .jingxuanList_box {
        display: flex;
        flex-direction: column;
        height: auto;
        width: 100%;

        >div:nth-child(1) {
          width: 100%;
          height: auto;
          box-sizing: border-box;
          padding-bottom: 10px;
          margin-bottom: 10px;

          >.img_box {
            width: 100%;

            >img {
              width: 100%;
              height: auto;

            }
          }

          >span {
            font-size: 16px !important;
          }

          >.jiaoxuesuoshu {
            >span {
              font-size: 12px !important;
              margin-bottom: 10px;
            }

            >.dianzanBox {
              >div {
                font-size: 12px;
              }
            }
          }

        }

        .jingxuan_ul {
          margin-left: 0;

          >li {
            width: 48%;
            height: auto;

            >span {
              font-size: 16px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              margin: 5px 0;
            }

            >.img_box {
              border-radius: 5px;
            }

            >.jiaoxuesuoshu {
              display: flex;
              flex-direction: column;

              >span {
                font-size: 12px;
                margin-bottom: 5px;

              }

              >.dianzanBox {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  .home_content>.jingxuan>.jingxuanList_box>.jingxuan_ul>li>.img_box {
    height: 100px;
  }

  .home_content .video_box {
    display: none !important;
  }

  .jingxuanExp_titlephone {
    display: flex;
  }

  .jingxuanExp_titlephone {
    display: flex;

    >span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      margin-bottom: 15px;

      >.transverse_line {
        width: 20px;
        height: 3px;
        background: #0957D9;
        border-radius: 0px;
        margin: 0 8px;
      }
    }
  }

  .jingxuan {
    margin-bottom: 10px !important;
  }

  .home_content>.tongzhiand>div:nth-child(1)>.video_list {
    display: block;
    white-space: nowrap;
    overflow-x: scroll;
    padding: 0 7.3%;

    >li {
      width: 48%;
      display: inline-block;
      height: 200px;

      >.img_box {
        height: 100px;
      }
    }
  }

  .paihang_box {
    display: none !important;
  }

  .paihanglist_box {
    flex-direction: column;
    padding: 0 7.3%;
    height: auto !important;

    >ul {
      width: 100% !important;
      margin-bottom: 10px;

      >li {
        >span {
          font-size: 12px;
        }
      }
    }
  }

  .paihang_top {
    flex-direction: column;
    align-items: center;

    >.nav_box {
      width: 80px;
      display: flex;
      border-radius: 20px;
      overflow: hidden;
      align-items: center;
      overflow: hidden;

      >span {
        padding: 2px 0px;
        background-color: #dbdbdb;
        color: #fff;
        height: 100%;
        // display: flex;
        align-items: center;
        cursor: pointer;
        color: #333;
        font-size: 12px;
        text-align: center;
        width: 50%;
      }

      >.chosed_nav {
        background-color: #0958d9;
        color: #fff;
      }
    }
  }

  .gonggao_title {
    display: none !important;
  }

  .tongzhiandnews {
    flex-direction: column;
    height: auto !important;
    padding: 0 7.3% !important;
    width: 100%;

    >div {
      width: 100% !important;
      margin-bottom: 30px;
    }
  }

  .home_content>.tongzhiandnews {
    width: 100%;
  }

  .home_content>.tongzhiandnews>div>ul>li>div>span {
    width: auto;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: block;
  }

  .home_content>.tongzhiandnews>div>ul>li>div:last-child {
    width: auto;
    font-size: 12px;
    display: none;
  }

  .home_content>.tongzhiand>div:nth-child(1)>.video_list>li>.jieshao>span:nth-child(1) {
    font-size: 16px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }

  .home_content>.tongzhiandnews>div>ul>li>div {
    width: 90%;
  }
}
</style>
